import React, { useState, useEffect} from 'react';
import {Modal} from "react-bootstrap";
import picture from "../Data/BobDole.png";

function AdPopUp() {
    const [count, setCount] = React.useState(0);
    const [adShow, setAdShow] = useState(false)
    useEffect(
        () => setTimeout(() => setAdShow(true), 12000),
        []
      );
    

    return(
        <>
            <Modal show={adShow} onHide = {() => setAdShow(false)}>
                <Modal.Body>
                    <div className="card text-white bg-info mb-3" style={{max_width: "20rem"}} >
                        <div className="card-header">Zombie Bob Dole 2024</div>
                        <div className="card-body">
                            <img className ="Bucksimage" src={picture} style={{ height: "40%", width: "90%"}}/>
                            <h4 className="card-title">
                            <a href={"http://www.dolekemp96.org/agenda/issues/internet.htm"}>CLICK HERE FOR MORE INFO!</a>
                                
                            </h4>
                            <p className="card-text">More opportunities. Smaller government. Stronger and safer families</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AdPopUp;